import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import config from "../config/config";

const AddCardSlider = () => {
    const navigate = useNavigate()
    
    const [formData, setFormData] = useState({
        cardName: "",
        cardCollageTitle: "",
        linkname1: "",
        linkname2: "",
        linkname3: "",
    });

    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState("");

    const cardNameOptions = ["Engineering", "Management", "Arts", "Medical", "Design", "LAW"];

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

        setErrors({
            ...errors,
            [e.target.name]: "",
        });
    };

    const validate = () => {
        const newErrors = {};
        Object.keys(formData).forEach((key) => {
            if (!formData[key]) {
                newErrors[key] = "This field is required";
            }
        });
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {
            const response = await axios.post(`${config.API_BASE_URL}/api/admin/create_cardslider`, formData);
            // console.log("Success:", response.data);
            setSuccessMessage("Form submitted successfully!");
            if (response.data.code === 201) {
                alert('Card Slider created successfully');
                navigate("/admin/cardslider");
                console.log(response.data);
            } else {
                alert('Error creating course');
                console.error(response.data);
            }
            setFormData({
                cardName: "",
                cardCollageTitle: "",
                linkname1: "",
                linkname2: "",
                linkname3: "",
            });
        } catch (error) {
            console.error("Error:", error.response?.data || error.message);
            setSuccessMessage("Something went wrong. Please try again.");
        }
    };

    return (
        <div className="container mt-4 pt-4">
           <div className="row">
            <div className="col-lg-2"></div>
            <div className="col-lg-10">
            <h2 className="mb-4">Card Link Page Form</h2>
            {successMessage && (
                <div className="alert alert-info" role="alert">
                    {successMessage}
                </div>
            )}
            <form onSubmit={handleSubmit}>
                {/* cardName dropdown */}
                <div className="mb-3">
                    <label htmlFor="cardName" className="form-label ">Card Name</label>
                    <select
                        id="cardName"
                        name="cardName"
                        className={`form-select ${errors.cardName ? "is-invalid" : ""}`}
                        value={formData.cardName}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select a card</option>
                        {cardNameOptions.map((option, index) => (
                            <option key={index} value={option}>{option}</option>
                        ))}
                    </select>
                    {errors.cardName && <div className="invalid-feedback">{errors.cardName}</div>}
                </div>

                {/* Other input fields */}
                <div className="mb-3">
                    <label htmlFor="cardCollageTitle" className="form-label">Card Collage Title</label>
                    <input
                        type="text"
                        className={`form-control ${errors.cardCollageTitle ? "is-invalid" : ""}`}
                        id="cardCollageTitle"
                        name="cardCollageTitle"
                        value={formData.cardCollageTitle}
                        onChange={handleChange}
                        required
                    />
                    {errors.cardCollageTitle && <div className="invalid-feedback">{errors.cardCollageTitle}</div>}
                </div>

                {["linkname1", "linkname2", "linkname3"].map((link, idx) => (
                    <div className="mb-3" key={link}>
                        <label htmlFor={link} className="form-label">Link Name {idx + 1}</label>
                        <input
                            type="text"
                            className={`form-control ${errors[link] ? "is-invalid" : ""}`}
                            id={link}
                            name={link}
                            value={formData[link]}
                            onChange={handleChange}
                            required
                        />
                        {errors[link] && <div className="invalid-feedback">{errors[link]}</div>}
                    </div>
                ))}

                <button type="submit" className="btn btn-primary">Submit</button>
            </form>
            </div>
           </div>
        </div>
    );
};

export default AddCardSlider;
